// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/ui/accordion.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/ui/accordion.tsx");
  import.meta.hot.lastModified = "1717182690461.277";
}
// REMIX HMR END

import { forwardRef } from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
const Accordion = AccordionPrimitive.Root;
const AccordionItem = forwardRef(_c = ({
  className,
  ...props
}, ref) => <AccordionPrimitive.Item ref={ref} className="data-[state=open]:border-b border-neutral-300" {...props} />);
_c2 = AccordionItem;
const AccordionTrigger = forwardRef(_c3 = ({
  className,
  children,
  ...props
}, ref) => <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger ref={ref} className="flex flex-1 justify-between items-center py-5 border-b text-secondary-700 border-neutral-300 transition-all [&[data-state=open]>svg]:rotate-180" {...props}>
      {children}
      <ChevronDownIcon className="h-5 w-5 text-secondary-700 shrink-0 transition-transform duration-200" />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>);
_c4 = AccordionTrigger;
const AccordionContent = forwardRef(_c5 = ({
  className,
  children,
  ...props
}, ref) => <AccordionPrimitive.Content ref={ref} className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down" {...props}>
    {children}
  </AccordionPrimitive.Content>);
_c6 = AccordionContent;
export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
var _c, _c2, _c3, _c4, _c5, _c6;
$RefreshReg$(_c, "AccordionItem$forwardRef");
$RefreshReg$(_c2, "AccordionItem");
$RefreshReg$(_c3, "AccordionTrigger$forwardRef");
$RefreshReg$(_c4, "AccordionTrigger");
$RefreshReg$(_c5, "AccordionContent$forwardRef");
$RefreshReg$(_c6, "AccordionContent");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;